import React from "react";

export const Heading = ({ children }) => (
  <h3 className="tw-font-light tw-text-2xl">{children}</h3>
);